module.exports = __webpack_public_path__ + "static/media/hero-pricing.6c56afad.svg";